/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import MoserObject from './MoserObject';
import MoserObjectUtils from './MoserObjectUtils';
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
//@import com/ibm/bi/platform/moser/common/utils/MoserObjectUtils (runtime) // propertyOverrideForTaxonomyType

/**
 * Specifies the item data classification and whether it represents a geographic or time related concept. <p>Java class for taxonomyType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="taxonomyType"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="domain"&gt; &lt;simpleType&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}string"&gt; &lt;enumeration value="cognos"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; &lt;/element&gt; &lt;element name="class"&gt; &lt;simpleType&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}string"&gt; &lt;enumeration value="cNone"/&gt; &lt;enumeration value="cTime"/&gt; &lt;enumeration value="cGeoLocation"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; &lt;/element&gt; &lt;element name="family"&gt; &lt;simpleType&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}string"&gt; &lt;enumeration value="cNone"/&gt; &lt;enumeration value="cDate"/&gt; &lt;enumeration value="cYear"/&gt; &lt;enumeration value="cQuarter"/&gt; &lt;enumeration value="cSeason"/&gt; &lt;enumeration value="cMonth"/&gt; &lt;enumeration value="cWeek"/&gt; &lt;enumeration value="cDay"/&gt; &lt;enumeration value="cHour"/&gt; &lt;enumeration value="cMinute"/&gt; &lt;enumeration value="cSecond"/&gt; &lt;enumeration value="cContinent"/&gt; &lt;enumeration value="cSubContinent"/&gt; &lt;enumeration value="cCountry"/&gt; &lt;enumeration value="cRegion"/&gt; &lt;enumeration value="cStateProvince"/&gt; &lt;enumeration value="cCounty"/&gt; &lt;enumeration value="cCity"/&gt; &lt;enumeration value="cPostalCode"/&gt; &lt;enumeration value="cStreetAddress"/&gt; &lt;enumeration value="cPosition"/&gt; &lt;enumeration value="cLatitude"/&gt; &lt;enumeration value="cLongitude"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; &lt;/element&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class TaxonomyType extends MoserObject{

	domain = null;

	clazz = null;

	family = null;



	/**
	 * Gets the value of the domain property.
	 * @return {String} possible object is {@link String}
	 */
	getDomain() {
		return this.domain;
	}

	/**
	 * Sets the value of the domain property.
	 * @param {String} value allowed object is {@link String}
	 */
	setDomain(value) {
		var oldValue = this.domain;
		this.domain = value;
		this._setAndNotify(128, oldValue, value, false, false);
		MoserObjectUtils.propertyOverrideForTaxonomyType(this);
	}

	/**
	 * Gets the value of the clazz property.
	 * @return {String} possible object is {@link String}
	 */
	getClazz() {
		return this.clazz;
	}

	/**
	 * Sets the value of the clazz property.
	 * @param {String} value allowed object is {@link String}
	 */
	setClazz(value) {
		var oldValue = this.clazz;
		this.clazz = value;
		this._setAndNotify(127, oldValue, value, false, false);
		MoserObjectUtils.propertyOverrideForTaxonomyType(this);
	}

	/**
	 * Gets the value of the family property.
	 * @return {String} possible object is {@link String}
	 */
	getFamily() {
		return this.family;
	}

	/**
	 * Sets the value of the family property.
	 * @param {String} value allowed object is {@link String}
	 */
	setFamily(value) {
		var oldValue = this.family;
		this.family = value;
		this._setAndNotify(126, oldValue, value, false, false);
		MoserObjectUtils.propertyOverrideForTaxonomyType(this);
	}

	/**
	 * Creates a new instance of <code>TaxonomyType</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> TaxonomyType</code> object from.
	 * @return {TaxonomyType} an object of type <code>TaxonomyType</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createTaxonomyType();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "TaxonomyType";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 128, "domain", null));
		featureList.push(this.createFeature(false, false, false, 127, "clazz", null));
		featureList.push(this.createFeature(false, false, false, 126, "family", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 126:
			this.setFamily((value));
			break;
		case 127:
			this.setClazz((value));
			break;
		case 128:
			this.setDomain((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 126:
			return this.getFamily();
		case 127:
			return this.getClazz();
		case 128:
			return this.getDomain();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 126:
			return this.getFamily();
		case 127:
			return this.getClazz();
		case 128:
			return this.getDomain();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/TaxonomyType.js